import { CARE_STAFF_ROLES } from '@aithora/shared';
import { useConsoleRole } from '../session/SessionContext';
import { OperatorOverview } from './overview/OperatorOverview';
import { FacilityAdminOverview } from './overview/FacilityAdminOverview';
import { CareStaffOverview } from './overview/CareStaffOverview';
import { PartnerOverview } from './overview/PartnerOverview';
import { ReadOnlyNote } from '../ui/ReadOnly';
import { FleetScope } from '../session/DemoScope';

/**
 * Overview, per role (design: roleIsOperator / roleIsAdmin / roleIsCare). The role comes
 * from the session only (or the role a Super Admin is viewing as). Partner has its own
 * read-only Overview across buildings (Console V5).
 */
export function Overview() {
  const { role } = useConsoleRole();
  if (!role) return null;
  return <div className="v9type" style={{ display: 'contents' }}>{byRole(role)}</div>;
}

function byRole(role: NonNullable<ReturnType<typeof useConsoleRole>['role']>) {
  if (role === 'ADMIN') return <FacilityAdminOverview />;
  if (CARE_STAFF_ROLES.has(role)) return <CareStaffOverview />;
  if (role === 'PARTNER') return <PartnerOverview />;
  return (
    <>
      <ReadOnlyNote />
      {/* The fleet view can mix real and demo buildings: every figure keeps its own tag. */}
      <FleetScope>
        <OperatorOverview />
      </FleetScope>
    </>
  );
}
